import {addCircularTabFocus, focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {CloseButton} from '../../../common/close-button'
import {StyledButton} from '../../styled-button'
import {classes} from '../error-modal.st.css'
import {TicketLimitReachedProps} from './interfaces'

export const TicketLimitReached = ({ticketLimitPerOrder, setSeatingError}: TicketLimitReachedProps) => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()

  React.useEffect(() => {
    focusElement({selector: hookToAttributeSelector(DH.MODAL_TITLE)})
    addCircularTabFocus(
      hookToAttributeSelector(DH.CLOSE_BUTTON),
      hookToAttributeSelector(DH.TICKET_LIMIT_REACHED_MODAL_BUTTON),
    )
  }, [])

  return (
    <div className={classes.container}>
      <div className={classNames(classes.content, {[classes.desktopContent]: !isMobile})}>
        <CloseButton
          className={classes.closeIcon}
          closeButtonAsButton={false}
          closeModal={() => setSeatingError(null)}
        />
        <div className={classes.text}>
          <Text
            data-hook={DH.MODAL_TITLE}
            tagName="h2"
            className={classNames(classes.title, {[classes.mobileTitle]: isMobile})}
          >
            {t('seatings_ticketLimitReachedModal_title')}
          </Text>
          <Text tagName="p" className={classes.subtitle}>
            {ticketLimitPerOrder === 1
              ? t('seatings_ticketLimitReachedModal_subtitle_singular')
              : t('seatings_ticketLimitReachedModal_subtitle', {limit: ticketLimitPerOrder})}
          </Text>
        </div>
        <StyledButton
          dataHook={DH.TICKET_LIMIT_REACHED_MODAL_BUTTON}
          onClick={() => setSeatingError(null)}
          fullWidth={false}
        >
          {t('seatings_ticketLimitReachedModal_button')}
        </StyledButton>
      </div>
    </div>
  )
}
